import React from 'react';
import '../../styles/background-effects.css';

const WorkspaceAuroraBackground: React.FC = () => (
  <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
    <div className="absolute inset-0 bg-gradient-to-br from-teal-light via-teal-dark to-teal-800 opacity-10" />

    <div className="absolute -top-40 -left-40 w-80 h-80 bg-teal-light rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse" />
    <div className="absolute -bottom-40 -right-40 w-80 h-80 bg-teal-dark rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse animation-delay-1000" />
    <div className="absolute top-40 right-40 w-80 h-80 bg-teal-800 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse animation-delay-2000" />
    <div className="absolute top-1/2 left-1/2 w-96 h-96 -translate-x-1/2 -translate-y-1/2 bg-teal-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 aurora-float animation-delay-1500" />

    <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-white rounded-full mix-blend-multiply filter blur-3xl opacity-15 white-glow animation-delay-500" />
    <div className="absolute bottom-1/4 right-1/4 w-72 h-72 bg-white rounded-full mix-blend-multiply filter blur-3xl opacity-12 teal-white-flow animation-delay-1200" />
    <div className="absolute top-3/4 left-3/4 w-56 h-56 bg-white rounded-full mix-blend-multiply filter blur-3xl opacity-18 white-glow animation-delay-1800" />

    <div className="absolute inset-0 teal-gradient-overlay" />
  </div>
);

export default WorkspaceAuroraBackground;
